
<div v-if="files.length" class="file-list">
  <div v-for="file in files" :key="file.name" class="file-item">
    <div class="d-flex align-items-start justify-content-between mb-3">
      <div class="d-flex">
        <div class="bg-white p-2 mr-4" style="border-radius: 8px; height: fit-content;">
          <v-icon color="#3F3F3F">mdi-file</v-icon>
        </div>
        <div class="d-flex flex-column">
          <span class="color-dark-grey-1 font-weight-bold" style="font-size: 14px; word-break: break-word;">{{ file.name }}</span>
          <span class="color-grey-1" style="font-size: 12px;">{{ (file.size / 1024 / 1024).toFixed(2) }} MB</span>
        </div>
      </div>
      <div class="file-actions" @click="removeFile(file)">
        <button icon><v-icon small>mdi-close</v-icon></button>
      </div>
    </div>
    <div class="d-flex align-items-center" v-if="file.uploading">
      <v-progress-linear height="10" style="width: 100% !important;" :color="getProgressColor(file.progress)"
        rounded :buffer-value="Math.round(file.progress)"></v-progress-linear>
      <div class="ml-4 color-grey-1" style="font-size: 12px;">{{ Math.round(file.progress) }}%</div>
    </div>
    <div class="d-flex align-items-center" v-if="!file.uploading">
      <div class="d-flex align-items-center mr-3">
        <v-icon small color="#3DA568">mdi-check</v-icon>
        <span class="ml-2 font-weight-bold" style="font-size: 12px; color: #3DA568;">Ready to upload</span>
      </div>
    </div>
  </div>
</div>
